"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var Icons = _interopRequireWildcard(require("../Icons"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var IconsList = {};
Object.keys(Icons).map(function (IconKey) {
  return IconsList[IconKey] = Icons[IconKey];
});

var AddEntityButton = function AddEntityButton(_ref) {
  var fullwidth = _ref.fullwidth,
      icon = _ref.icon,
      onClick = _ref.onClick,
      name = _ref.name,
      otherProps = _objectWithoutProperties(_ref, ["fullwidth", "icon", "onClick", "name"]);

  var ChosenIcon = IconsList[icon];
  return /*#__PURE__*/_react.default.createElement(StyledButton, _extends({
    fullwidth: fullwidth,
    onClick: onClick
  }, otherProps), ChosenIcon && /*#__PURE__*/_react.default.createElement(ChosenIcon, {
    size: 40
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "label"
  }, name));
};

var StyledButton = _styledComponents.default.button.withConfig({
  displayName: "StyledButton"
})(["min-width:25rem;display:flex;flex-direction:column;justify-content:center;align-items:center;padding:2rem;border-radius:0.5rem;border:2px dashed ", ";background-color:#f0f1f3;cursor:pointer;transition:0.15s ease-in-out;width:", ";svg{path{stroke:", ";fill:", ";transition:0.15s ease-in-out;}}.label{margin-top:5px;font-size:1.4rem;line-height:120%;font-family:", ";color:", ";transition:0.15s ease-in-out;}&:hover{border:2px dashed ", ";background-color:", ";svg{path{stroke:", ";fill:", ";}}.label{color:", ";}}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.ui.outline;
}, function (_ref3) {
  var fullwidth = _ref3.fullwidth;
  return fullwidth ? '100%' : 'auto';
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.ui.outline;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.ui.outline;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.font;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.typo.highlight;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.brand.primary;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.brand.lightest;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.brand.primary;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.brand.primary;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.brand.primary;
});

StyledButton.displayName = 'StyledButton';
AddEntityButton.defaultProps = {
  icon: 'IconPlusFilled',
  otherProps: {},
  fullwidth: false
};
AddEntityButton.propTypes = {
  icon: _propTypes.string,
  name: _propTypes.string.isRequired,
  onClick: _propTypes.func.isRequired,
  otherProps: _propTypes.object,
  fullwidth: _propTypes.bool
};
var _default = AddEntityButton;
exports.default = _default;